/**
 * Created by abdulhafeth on 12/14/15.
 */
export var PayrollAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = publicConfiguration.PayrollServerBaseURL;
    _protected.setApiUrl(url);

    self.getPayRollSchemaForm = function (brandId, channel, isRehire) {
        var deferred = $q.defer();

        isRehire = !!isRehire;
        var promise;

        if (isRehire) {
            promise = _protected.request("brands/" + brandId + "/channels/" + channel + "/rehire", 'GET', {});
        } else {
            promise = _protected.request("brands/" + brandId + "/channels/" + channel, 'GET', {});
        }

        promise
            .then(function (result) {

                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    if(result.data){
                        deferred.reject(result.data);
                    }else{
                        deferred.reject(result);
                    }
                }
            }, function (err) {
                if (err.data) {
                    deferred.reject(err.data);
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };


    self.getUserPayrollInfo = function (brandId, channel, userId, prospectId, applicationId) {
        var deferred = $q.defer();

        var payload = {};

        if (prospectId) {
            payload.prospect_id = prospectId;
        } else if (applicationId) {
            payload.application_id = applicationId;
        }

        _protected.uniqueRequest("brands/" + brandId + "/channels/" + channel + "/users/" + userId + "/info", 'GET', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.info);
                }
                else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateLastEmployeeId = function (brandId, channel) {
        var deferred = $q.defer();

        _protected.uniqueRequest("brands/" + brandId + "/channels/" + channel + "/generate_last_employee_id", 'POST')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserPayrollSatus= function (brandId, channel, userId) {
        var deferred = $q.defer();

        _protected.uniqueRequest("brands/" + brandId + "/channels/" + channel + "/users/" + userId + "/status", 'GET', {})
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.user_status);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.searchWorkdayBNBEmployees = function (brandId, userInfo) {
        var deferred = $q.defer();

        _protected.uniqueRequest("brands/" + brandId + "/channels/BNB_WORKDAY/check_duplicates", 'POST', { user: userInfo })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data || []);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.searchWorkdayEmployees = function (brandId, userInfo) {
        var deferred = $q.defer();

        _protected.uniqueRequest("brands/" + brandId + "/channels/WORKDAY/check_duplicates", 'POST', { user: userInfo })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data || []);
                }
                else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendToPayroll = function (payRollOptions, brandId, channel, isRehire) {
        var deferred = $q.defer();
        var apiURL = '';
        isRehire = !!isRehire;

        if (brandId) {
            if (isRehire) {
                apiURL = "brands/" + brandId + "/channels/" + channel + "/rehire";
            }
            else {
                apiURL = "brands/" + brandId + "/channels/" + channel;
            }

        } else {
            if (isRehire) {
                apiURL = "brands/channels/" + channel + "/rehire";
            } else {
                apiURL = "brands/channels/" + channel;
            }
        }

        _protected.uniqueRequest(apiURL, 'POST', payRollOptions)
            .then(function (result) {

                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    if (result.data.data.generated_file_url) {
                        deferred.resolve(result.data.data.generated_file_url);
                    } else {
                        deferred.resolve(result.data.data);
                    }
                } else {
                    if(result.data){
                        deferred.reject(result.data);
                    }else{
                        deferred.reject(result);
                    }
                }
            }, function (err) {
                if (err.data) {
                    deferred.reject(err.data);
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.checkExternalUsers = function (brandId, channelCode, ssns) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!channelCode) {
            throw "No Channel Code";
        }

        var payload = {
            ssns: ssns.join(',')
        };

        _protected.request("brands/" + brandId + "/channels/" + channelCode + "/external_users", 'GET', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.checkExistenceUsers = function (brandId, channelCode, usersInfo) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!channelCode) {
            throw "No Channel Code";
        }

        _protected.request("brands/" + brandId + "/channels/" + channelCode + "/users/check_existence", 'POST', {users: [usersInfo]})
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPayrollAuditDetails = function (brandId, channelCode, status, prospectId, applicationId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var payload = {
            status: status
        }

        if (prospectId) {
            payload.prospect_id = prospectId;
        } else if (applicationId) {
            payload.application_id = applicationId;
        }

        _protected.request( 'brands/' + brandId + '/channels/' + channelCode + '/users/audits', 'GET', payload).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getEmploymentFlow = async (brandId, channelCode, params) => {
        const result = await _protected.request(`brands/${brandId}/channels/${channelCode}/employment_flow`, 'GET', params);

        if (result?.data?.data && result.data.status_code === 200) {
            return result.data.data;
        }

        throw result;
    };
});

PayrollAPI.PAYROLL_CHANNELS = {};
PayrollAPI.PAYROLL_CHANNELS.ADP = "ADP";
PayrollAPI.PAYROLL_CHANNELS.PAYCOM = "PAYCOM";
PayrollAPI.PAYROLL_CHANNELS.INFOSYNC_ULTIPRO = "INFOSYNC_ULTIPRO";
PayrollAPI.PAYROLL_CHANNELS.ADP_CSV = "ADP_CSV";
PayrollAPI.PAYROLL_CHANNELS.SAGE_50 = "SAGE_50";
PayrollAPI.PAYROLL_CHANNELS.PAYCHEX = "PAYCHEX";
PayrollAPI.PAYROLL_CHANNELS.FOURTH = "FOURTH";
PayrollAPI.PAYROLL_CHANNELS.PAYCHEX_PREVIEW = "PAYCHEX_PREVIEW";
PayrollAPI.PAYROLL_CHANNELS.VALIANT = "VALIANT";
PayrollAPI.PAYROLL_CHANNELS.ISOLVED = "ISOLVED";
PayrollAPI.PAYROLL_CHANNELS.ADP_POSITION = "ADP_POSITION";
PayrollAPI.PAYROLL_CHANNELS.PAYLOCITY = "PAYLOCITY";
PayrollAPI.PAYROLL_CHANNELS.ACCUDATA = "ACCUDATA";
PayrollAPI.PAYROLL_CHANNELS.AAP = "AAP";
PayrollAPI.PAYROLL_CHANNELS.ULTIPRO = "ULTIPRO";
PayrollAPI.PAYROLL_CHANNELS.CERIDIAN = "CERIDIAN";
PayrollAPI.PAYROLL_CHANNELS.EPS = "EPS";
PayrollAPI.PAYROLL_CHANNELS.BENEFIT_MALL = "BENEFIT_MALL";
PayrollAPI.PAYROLL_CHANNELS.PAPERCHASE = "PAPERCHASE";
PayrollAPI.PAYROLL_CHANNELS.ENGAGE = "ENGAGE";
PayrollAPI.PAYROLL_CHANNELS.STAFFOLOGY = "STAFFOLOGY";
PayrollAPI.PAYROLL_CHANNELS.VISMA = "VISMA";
PayrollAPI.PAYROLL_CHANNELS.FOURTH_API = "FOURTH_API";
PayrollAPI.PAYROLL_CHANNELS.ADP_BRIDGE = "ADP_BRIDGE";
PayrollAPI.PAYROLL_CHANNELS.AVITUS = "AVITUS";
PayrollAPI.PAYROLL_CHANNELS.HARRI_CSV = "HARRI_CSV";
PayrollAPI.PAYROLL_CHANNELS.WORKPULSE = "WORKPULSE";
PayrollAPI.PAYROLL_CHANNELS.STRATEX = "STRATEX";
PayrollAPI.PAYROLL_CHANNELS.BNB_WORKDAY = "BNB_WORKDAY";
PayrollAPI.PAYROLL_CHANNELS.S4LABOUR = "S4LABOUR";
PayrollAPI.PAYROLL_CHANNELS.ALLIANCE = "ALLIANCE";
PayrollAPI.PAYROLL_CHANNELS.NETCHEX = "NETCHEX";
PayrollAPI.PAYROLL_CHANNELS.ZELLIS = "ZELLIS";
PayrollAPI.PAYROLL_CHANNELS.PROLIANT = "PROLIANT";
PayrollAPI.PAYROLL_CHANNELS.PAYCOR = "PAYCOR";
PayrollAPI.PAYROLL_CHANNELS.PAPA_JOHN_UNITED = "PAPA_JOHN_UNITED";
PayrollAPI.PAYROLL_CHANNELS.PAYLOCITY_API = "PAYLOCITY_API";
PayrollAPI.PAYROLL_CHANNELS.ACCESS_GROUP = "ACCESS_GROUP";
PayrollAPI.PAYROLL_CHANNELS.WORKDAY = "WORKDAY";

PayrollAPI.PAYROLL_CHANNELS.NEED_DOWNLOAD_FILE = [
    PayrollAPI.PAYROLL_CHANNELS.ADP_CSV,
    PayrollAPI.PAYROLL_CHANNELS.SAGE_50,
    PayrollAPI.PAYROLL_CHANNELS.PAYCOM,
    PayrollAPI.PAYROLL_CHANNELS.INFOSYNC_ULTIPRO,
    PayrollAPI.PAYROLL_CHANNELS.PAYCHEX,
    PayrollAPI.PAYROLL_CHANNELS.FOURTH,
    PayrollAPI.PAYROLL_CHANNELS.PAYCHEX_PREVIEW,
    PayrollAPI.PAYROLL_CHANNELS.VALIANT,
    PayrollAPI.PAYROLL_CHANNELS.ADP_POSITION,
    PayrollAPI.PAYROLL_CHANNELS.PAYLOCITY,
    PayrollAPI.PAYROLL_CHANNELS.ACCUDATA,
    PayrollAPI.PAYROLL_CHANNELS.AAP,
    PayrollAPI.PAYROLL_CHANNELS.BENEFIT_MALL,
    PayrollAPI.PAYROLL_CHANNELS.PAPERCHASE,
    PayrollAPI.PAYROLL_CHANNELS.AVITUS,
    PayrollAPI.PAYROLL_CHANNELS.HARRI_CSV,
    PayrollAPI.PAYROLL_CHANNELS.WORKPULSE,
    PayrollAPI.PAYROLL_CHANNELS.STRATEX,
    PayrollAPI.PAYROLL_CHANNELS.PAPA_JOHN_UNITED
];

PayrollAPI.PAYROLL_STATUS = {
    FAILED: "FAILED",
    IN_PROGRESS: "IN_PROGRESS",
    SUCCESS: "SUCCESS"
}

PayrollAPI.EMPLOYMENT_FLOW_TYPE = {
    NEW_HIRE: "NEW_HIRE",
    REHIRE: "REHIRE"
}

PayrollAPI.PAYROLL_CHANNELS.MULTIPLE_SERVER_SEND = [
    PayrollAPI.PAYROLL_CHANNELS.EPS,
    PayrollAPI.PAYROLL_CHANNELS.VISMA,
    PayrollAPI.PAYROLL_CHANNELS.ADP_BRIDGE
];
